import useNewsTipModalAction from './useNewsTipModalAction'
export default useNewsTipModalAction
